export default {
    apiTimeout: 30000,
    tokenAge: 10 * 24 * 60 * 60 * 1000, //token失效时间
    url: '',
    gaodeMapKey: '2faaca36dc73b043479bb59b21e697fc',
    // api: 'http://182.151.11.69:31021', //测试环境
    // api: 'http://10.195.158.47:31002', //铁路
    api: 'https://saasadmin.csin.net.cn',
    debug: true
};



// WEBPACK FOOTER //
// ./src/js/utils/config.js